import React from 'react';
import PropTypes from 'prop-types';

import {PROPERTY_IMAGE_PLACEHOLDER} from '../../constants';

import './CardImage.less';

export const CardImage = ({imageUri = PROPERTY_IMAGE_PLACEHOLDER, layout}) => {
    const className = `CardImage ${layout}`;

    return (
        <div
            className={className}
            data-testid={
                imageUri === PROPERTY_IMAGE_PLACEHOLDER
                    ? 'placeholder-card-image'
                    : 'card-image'
            }
            style={{backgroundImage: `url(${imageUri})`}}
        />
    );
};

CardImage.PropTypes = {
    imageUri: PropTypes.string,
    layout: PropTypes.string,
};
